// src/layouts/AdminLayout.jsx
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import AdminSideNav from '../components/AdminSideNav/AdminSideNav';
import styles from './AdminLayout.module.css';

const AdminLayout = () => {
    const [isSidebarVisible] = useState(true);

    return (
        <div className={styles.adminLayoutContainer}>
            <Navbar />
            <div className={styles.adminPageWrapper}>
                <AdminSideNav className={!isSidebarVisible ? styles.adminSidebarHidden : ''} /> {/* Pass className */}
                <main className={`${styles.adminMainContent} ${!isSidebarVisible ? styles.adminMainContentFullWidth : ''}`}>
                    <Outlet /> 
                </main>
            </div>
            <Footer />
        </div>
    );
};

export default AdminLayout;